module.exports = __webpack_public_path__ + "static/media/header_banner.1f1710bc.svg";